

















import { Vue, Component } from 'vue-property-decorator'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { CandidatInterface } from '@/types/Candidat'
/**
 * Composant relatif aux épreuves écrites d'un candidat
 */
@Component({
    components: {
        'font-awesome-icon': FontAwesomeIcon
    }
})
export default class PopupEditCandidatInfEcrits extends Vue {
    currentCandidat?: CandidatInterface = undefined
    dataForTab: Array<any>  = []
    epreuvesIdInscriptions: number[] = []
    currentCandidat_serie_id = -1 // id de la série choisie pour la modification de la série du candidat.

    beforeMount () {
        this.initDatas()
    }

    initDatas() {
        this.dataForTab = []
        this.epreuvesIdInscriptions = []
        if (this.$store.state.candidat.editedCandidat) {
            this.currentCandidat = this.$store.state.candidat.editedCandidat
            this.currentCandidat_serie_id = this.$store.state.candidat.editedCandidat.serie_id
        }
    }
}
